import { useT } from "../../shared/i18n";
import { Banner, Button } from "../../shared/ui";

/** Replaces the console after a 401, with a way back to operator sign-in. */
export function SessionExpired({ onSignIn }: { onSignIn: () => void }) {
  const t = useT();
  return (
    <Banner
      tone="warning"
      title={t("admin.session.title")}
      action={<Button onClick={onSignIn}>{t("admin.session.signIn")}</Button>}
    >
      {t("admin.session.body")}
    </Banner>
  );
}
